












import Vue, { PropType } from 'vue';
import CellGrid from '@/components/CellGrid';
import { CellItem, GridItem, InstallationModuleData } from '@/types';
import { sortNumbers } from '@/utilities/sort';
import solarGrid from '@/helpers/solar-grid';

export default Vue.extend({
  components: {
    CellGrid,
  },

  props: {
    moduleData: Object as PropType<InstallationModuleData>,
  },

  computed: {
    numberOfPanels(): number {
      return this.moduleData.numberOfPanels!;
    },

    grid(): CellItem[] {
      return this.moduleData.grid ?? [];
    },

    cellColor() {
      return (cell: GridItem) => {
        const value = cell.value;
        const gridIndex = cell.index;

        if (value && gridIndex <= this.amountRequired) return 'grey darken-3';
        if (value && gridIndex > this.amountRequired) return 'error';
        if (!value && this.amountRemaining > 0) return 'success lighten-3';
        if (!value && this.amountRemaining <= 0) return 'error lighten-3';
      };
    },

    amountRequired(): number {
      return this.moduleData.numberOfPanels ?? 0;
    },

    amountFilled(): number {
      return this.grid.length ?? 0;
    },

    amountRemaining(): number {
      return this.amountRequired - this.amountFilled;
    },
  },

  watch: {
    numberOfPanels: {
      handler(current: number, previous: number) {
        this.updateGrid(current !== previous);
      },
    },
  },

  created() {
    this.updateGrid();
  },

  methods: {
    toggle(cell: GridItem) {
      const value = this.grid.slice() as CellItem[];

      const index = value.findIndex(i => i.col === cell.col && i.row === cell.row);

      if (index >= 0) {
        value.splice(index, 1);
      } else if (this.amountRemaining > 0) {
        value.push({ col: cell.col, row: cell.row });
      }

      this.moduleData.grid = value.map(item => ({ col: item.col, row: item.row }));

      this.$emit('change', this.moduleData);
    },

    updateGrid(forceUpdate: boolean = false) {
      const data = solarGrid(forceUpdate, this.moduleData);

      if (data !== this.moduleData) {
        Object.assign(this.moduleData, data);
        this.$emit('change', data);
      }
    },
  },
});
